export const styles = {
  container: 'flex flex-col bg-white px-6',

  title: {
    natural: 'mb-2 text-[15px] text-[#161E3A]',
    emphasised: 'mb-2 text-[15px] font-medium text-[#161E3A]',
  },

  text: {
    muted: 'text-[#6C727E]',
  },

  owner: {
    container: 'mb-4 flex items-center justify-between',
    left: 'flex items-center',
    avatar: 'mr-3 h-8 w-8 rounded-full bg-[#D4B5AD]',
    name: 'text-[14px] font-bold text-[#161E3A]',
    role: 'text-[14px] text-[#6C727E]',
  },

  skeletons: 'flex flex-col',

  sections: {
    // Section: Email Invitations
    email: {
      row: {
        container: 'mb-4 flex items-center justify-between',
        left: 'flex items-center',
        avatar: 'mr-3 h-8 w-8 rounded-full bg-mf-blue',
        textCol: 'flex flex-col',
        email: 'text-[14px] font-bold text-[#161E3A]',
        pending: 'text-[13px] text-[#6C727E]',
      },
      btn: {
        addInvitee: {
          left: {
            container: 'flex items-center',
            icon: 'mr-3 flex h-9 w-9 items-center justify-center rounded-md bg-[#F4F4F4]',
            text: 'text-[14px] text-[#161E3A]',
          },
        },
      },
    },
    // Section: Invitation Links
    link: {
      container: 'mb-3 mt-2 flex items-center justify-between',
      left: {
        container: 'flex items-center',
        icon: 'mr-3 flex h-9 w-9 items-center justify-center rounded-md bg-[#F4F4F4]',
        txt: 'text-[14px] text-[#161E3A]',
      },
      right: 'flex items-center gap-x-2',
    },
  },

  actionsRow: 'mt-2',

  footer: 'mt-3',
  footerText: 'text-[12px] text-[#6C727E]',
};
